export default "__VITE_ASSET__626da511__"